import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/gatsby-webpack/",
          "title": "Gatsby, customize webpack configuration"
        }}>{`A snippet`}</MDXTag>{` with code to add webpack aliases (in gatsby-node.js)`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// a Gatsby API hook function to customize webpack configuration (here, to add aliases) in gatsby-node.js
function onCreateWebpackConfig ({actions}) => {
    actions.setWebpackConfig({
        resolve: {
            alias: {
                "components": path.resolve("./src/components"),
                "content": path.resolve("./src/content"),
                "pages": path.resolve("./src/pages"),
                "generated": path.resolve("./src/generated"),
                "actb": path.resolve("./"),                                        
            }
        }
    })
}
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Gatsby, customize webpack configuration",
  "keywords": "webpack, aliases, Gatsby",
  "menu": "gatsby/webpack"
};
    